import { FunctionComponent, useContext } from 'react'
import styled, { css } from 'styled-components'
import contextStandardTeaser from '@contexts/standardTeaser'
import { StandardTeaserLayoutContextType } from '@contexts/standardTeaser'
import { PromoLabelProps } from '@widgets/Teaser/standard/types'
import { desktopCSS, mobileCSS, tabletCSS } from '@measures/responsive'

type StyledPromoLabelProps = Pick<
  StandardTeaserLayoutContextType,
  'isInMegaModule' | 'hasVideoOnlyStyle'
> &
  Pick<PromoLabelProps, 'isOnImage'>

const { StandardTeaserLayoutContext } = contextStandardTeaser

const StyledPromoLabel = styled.div<StyledPromoLabelProps>`
  ${({
    theme: {
      fonts: { goodOT },
      colors: {
        white,
        grey: { grey_100, grey_10 },
      },
    },
    isOnImage,
    isInMegaModule,
    hasVideoOnlyStyle,
  }) => {
    const basicCSS = css`
      font-family: ${goodOT}, 'Arial Narrow', Impact;
      text-transform: uppercase;
      font-size: 12px;
      font-weight: 500;
      letter-spacing: 2px;
      line-height: 1;
      color: ${hasVideoOnlyStyle ? grey_10 : grey_100};
      margin-bottom: 5px;
      display: inline-block;
    `

    const onImageCSS = css`
      color: ${white};
      text-shadow: 0 0 8px ${grey_100}, 0 0 8px ${grey_100};
      padding: 0;
      margin-bottom: 10px;
    `

    const hideCSS = css`
      display: none;
    `

    let cssDesktop
    if (isInMegaModule) {
      if (isOnImage) {
        cssDesktop = css`
          ${hideCSS}
        `
      } else {
        cssDesktop = css`
          ${basicCSS}
          margin-bottom: 0px;
        `
      }
    } else {
      if (isOnImage) {
        cssDesktop = css`
          ${basicCSS}
          ${onImageCSS}
        `
      } else {
        cssDesktop = css`
          ${hideCSS}
        `
      }
    }

    let cssTablet
    if (isInMegaModule) {
      if (isOnImage) {
        cssTablet = css`
          ${hideCSS}
        `
      } else {
        cssTablet = css`
          ${basicCSS}
          margin-bottom: 0px;
        `
      }
    } else {
      if (isOnImage) {
        cssTablet = css`
          ${basicCSS}
          ${onImageCSS}
        `
      } else {
        cssTablet = css`
          ${hideCSS}
        `
      }
    }

    let cssMobile
    if (isOnImage) {
      cssMobile = css`
        ${hideCSS}
      `
    } else {
      cssMobile = css`
        ${basicCSS};
        margin-bottom: 0px;
      `
    }

    return css`
      ${desktopCSS(css`
        ${cssDesktop}
      `)}

      ${tabletCSS(css`
        ${cssTablet}
      `)}

      ${mobileCSS(css`
        ${cssMobile}
      `)}
    `
  }}
`

const PromoLabel: FunctionComponent<PromoLabelProps> = ({
  children,
  isOnImage,
}) => {
  const { isInMegaModule, hasVideoOnlyStyle } = useContext(
    StandardTeaserLayoutContext
  )

  return (
    <StyledPromoLabel
      isOnImage={isOnImage}
      isInMegaModule={isInMegaModule}
      hasVideoOnlyStyle={hasVideoOnlyStyle}>
      {children}
    </StyledPromoLabel>
  )
}

export default PromoLabel
